//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import MultiTermHelpIcon from '@components/atoms/help-icon/MultiTermHelpIcon';
import { BodyBoldText } from '@components/atoms/text/Text';

export const PreferredCaptionHeader = () => {
  return (
    <TitleWrapper>
      <Title>Preferred Caption</Title>
      <MultiTermHelpIcon
        helpTerms={[
          {
            helpText:
              'Creating a Preferred Caption will change the caption of media that is owned by the end user. This caption will be shown in your onsite experiences.',
          },
        ]}
      />
    </TitleWrapper>
  );
};

const Title = styled(BodyBoldText)(
  ({ theme }) => `
    margin-right: ${theme.spacings[2]};
  `,
);

const TitleWrapper = styled.div(
  ({ theme }) => `
    display: flex;
    align-items: center;
    margin-bottom: ${theme.spacings[2]};
`,
);
